export default "__VITE_ASSET__CREciMny__"